import { event } from 'shared/experiments/utils/event'

export const EXIT_INTENT_POPUP_MODAL_ID = 'ExitIntentPopupModal'
export const EVENT_MODAL_CLICKED = event`Exit Intent popup clicked`
export const EVENT_MODAL_CLOSED = event`Exit Intent popup closed`
